import React, { useContext, useState } from "react";
import { Scheduler } from "../components/scheduler/Scheduler";
import { resourcesContext } from "../providers/resources";
import { boardContext } from "../providers/boardContext";
import { Loading } from "../components/Loading";
import EventModal from "../components/scheduler/Events/EventModal";
import { BoardSelectionModal } from "../components/boardSelection/BoardSelectionModal";

const SchedulerPage = () => {
    const { loading: resourcesLoading } = useContext(resourcesContext);
    const { loading: boardLoading, ready: boardReady, hasActiveSelection } = useContext(boardContext);
    const [selectedShift, setSelectedShift] = useState<string>();

    if (boardLoading || !boardReady) {
        return <Loading label="Loading board context" />;
    }

    if (!hasActiveSelection) {
        return <BoardSelectionModal />;
    }

    if (resourcesLoading) {
        return (
            <>
                <BoardSelectionModal />
                <Loading label={`Loading ${resourcesLoading}`} />
            </>
        );
    }

    return (
        <div>
            <BoardSelectionModal />
            <EventModal selectedShift={selectedShift} setSelectedShift={setSelectedShift} />
            <Scheduler openModal={setSelectedShift} />
        </div>
    );
};

export { SchedulerPage };
